import { render, staticRenderFns } from "./ruzhu.vue?vue&type=template&id=091fd8f4&scoped=true&"
import script from "./ruzhu.vue?vue&type=script&lang=js&"
export * from "./ruzhu.vue?vue&type=script&lang=js&"
import style0 from "./ruzhu.vue?vue&type=style&index=0&id=091fd8f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091fd8f4",
  null
  
)

export default component.exports